/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginationInfo } from '../models/PaginationInfo';
import type { SteamTrapCondenstateThresholdCrossed } from '../models/SteamTrapCondenstateThresholdCrossed';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SteamTrapCondensateThresholdCrossedService {

	constructor(public readonly httpRequest: BaseHttpRequest) {}

	/**
	 * get condensate threshold crossed events
	 * Retrieve a list of condensate temperature threshold crossings for a steam trap.
	 * @returns any A list of steam trap condensate temperature threshold crossed events.
	 * @throws ApiError
	 */
	public getSteamtrapsTrapidCondensateThresholdCrossings({
		trapId,
		page = 1,
		pageSize = 50,
	}: {
		trapId: string,
		/**
		 * A one-based index for the first page number to return from a paginated call.
		 */
		page?: number,
		/**
		 * The maximum number of items to return per page.
		 */
		pageSize?: number,
	}): CancelablePromise<{
		data?: Array<SteamTrapCondenstateThresholdCrossed>;
		paginationInfo?: PaginationInfo;
	}> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/steamtraps/{trapId}/condensate-threshold-crossings',
			path: {
				'trapId': trapId,
			},
			query: {
				'page': page,
				'pageSize': pageSize,
			},
			errors: {
				400: `The request is invalid.`,
				401: `The request did not include the correct authorization or the included authorization has expired.`,
				403: `The requested resource is not accessible to the currently authenticated client.`,
				404: `The requested resource was not found.`,
			},
		});
	}

}
